import { Injectable } from '@angular/core';
import {
    EXPORT_DESTINATION_MAP,
    OTHER_EXPORT_DESTINATION,
    REGISTRY_LABEL_EXPORT_DESTINATIONS
} from '@app/exports/models/constants/export-destinations.constants';

@Injectable({
    providedIn: 'root'
})
export class ExportDestinationService {

    /**
     * Returns the image path (src) for a given destination value.
     * @param destination exact destination value (can include spaces)
     * @returns string image path
     */
    getImageForDestination(destination: string): string {
        const value = EXPORT_DESTINATION_MAP.get(destination)
            ?? REGISTRY_LABEL_EXPORT_DESTINATIONS.get(destination);
        if (!value) {
            return OTHER_EXPORT_DESTINATION[1].image;
        }

        return value.image;
    }
}
